import React from 'react';

const PortfolioItem = ({ portfolios }) => {

  const portfolioList = portfolios.length ? (
    portfolios.map((portfolio, i) => {
      return (
        <div className="card" key={i}>
          <a href={portfolio.url} target="_blank" rel="noopener noreferrer"><i className="fas fa-external-link-alt"></i></a>
          <img src={"images/" + portfolio.thumbnail} alt="Portfolio" /> 
          <div className="card-content">
            <span className="card-title">{ portfolio.title }</span>
            <p>{ portfolio.description }</p>
          </div> 
        </div>
      );
    })
  ) : (
    <div>
      <p className="text-muted">There is no portfolio</p>
    </div>
  );

  return (
    <div className="card-list">
      { portfolioList }
      <div className="see-more">
        <a href="https://github.com/fadlihdytullah/">see more at github</a>
      </div>
    </div>
  );

}

export default PortfolioItem;